<template>
  <!-- 商户信息管理，用于通联支付对接 -->
  <div class="">
    <list-page>
      <search-condition @search="resetSearch" :show-search="true">
        <template #default>
          <el-input v-model="searchInfo.searchKey" placeholder="请输入姓名/手机号" @keydown.enter="resetSearch" clearable>
            <template #prefix>关键字</template>
          </el-input>
          <el-select v-model="searchInfo.classmateId" placeholder="请选择班组" clearable filterable>
            <template #prefix>班组</template>
            <el-option v-for="item in classmateList" :key="item.id" :value="item.id" :label="item.classmateName"></el-option>
          </el-select>
          <el-select v-model="searchInfo.lot" placeholder="请选择班组标段" clearable>
            <template #prefix>班组标段</template>
            <el-option v-for="item in lotList" :key="item.id" :value="item.dictCode" :label="item.dictName"/>
          </el-select>
        </template>
        <template #option>
          <page-button hasPerms="laborers:list:query" el-type="primary" @click="resetSearch" >查询</page-button>
          <!--          <page-button type="write" el-type="success" @click="$router.push(`/laborers/list/detail`)">新建</page-button>-->
        </template>
      </search-condition>
      <list-table>
        <laborers-table @data-update="resetSearch" :data="dataList" :lot-list="lotList"/>
      </list-table>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize"
                 :total-count="searchInfo.totalCount" @onLoad="queryList"/>
    </list-page>
  </div>
</template>

<script>

import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import ListPage from "@/components/h5/layout/ListPage.vue";
import Util from "@/util/util";
import {useRoute, useRouter} from "vue-router";
import LaborersTable from "@/views/h5/luqiao/display/LaborersTable.vue";
import contractWorkersApi from "@/api/dz-luqiao/contractWorkersApi";
import commonApi from "@/api/commonApi";
import util from "@/util/util";
import commonLqApi from "@/api/dz-luqiao/luqiaoCommonApi";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "LaborersList",
  components: {
    SearchCondition, FormPage,ListTable, ListPage, LaborersTable
  },
  data() {
    return {
      searchInfo: {},
      dataList: [],
      lotList: [],
      classmateList: [],
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  async created() {
    // if (!Util.loadPageData(this)) { // 加载缓存数据失败，初始化页面
    this.resetSearch();
    // 标段
    this.lotList = await commonApi.queryDictionaryList("LOT", (await util.getUserInfo()).merchantId)
    this.classmateList = await commonLqApi.queryClassmateNoPage(); // 施工班组
    // }
  },
  methods: {
    async queryList() {
      const {records, total} = await contractWorkersApi.list(this.searchInfo)
      this.dataList = records;
      this.searchInfo.totalCount = total;
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
  }
};
</script>

<style lang="scss" scoped>
</style>